import { render, staticRenderFns } from "./GoodReceiveCreate.vue?vue&type=template&id=1bc0f04e&scoped=true&"
import script from "./GoodReceiveCreate.vue?vue&type=script&lang=js&"
export * from "./GoodReceiveCreate.vue?vue&type=script&lang=js&"
import style0 from "./GoodReceiveCreate.vue?vue&type=style&index=0&id=1bc0f04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0f04e",
  null
  
)

export default component.exports